var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScienceFairLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 56,
    viewBox: "0 0 64 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 56,
    rx: 4,
    fill: "#152C73"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3975 18.2959H30.1961V28.0642L21.3975 18.2959ZM12.0856 24.0285H12C12 22.0701 12.5324 20.6251 13.5971 19.6934C14.6619 18.7617 16.3018 18.2959 18.5169 18.2959L30.1961 32.4706C30.1961 34.3529 29.6875 35.6982 28.6702 36.5062C27.6815 37.2953 26.0654 37.6898 23.8217 37.6898L12.0856 24.0285ZM12.0428 27.8788L20.5134 37.7041H12.0428V27.8788Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0856 18.2959H52V23.6863H50.5169C47.9406 23.6863 46.1818 23.2822 45.2406 22.4742C44.4706 21.8087 44.0856 20.7344 44.0856 19.2513V18.2959ZM33.9465 18.2959H41.6185V26.1105H47.3369V29.8324H41.6185V37.6756H33.9465V18.2959Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScienceFairLogin);
export default __webpack_public_path__ + "static/media/ScienceFairLogin.6d51caf7cb07f89f5b0400a928fbaa08.svg";
export { ForwardRef as ReactComponent };